__turbopack_context__.v({
  "container": "navYmm-module-scss-module__6XuKka__container",
  "containerWrapper": "navYmm-module-scss-module__6XuKka__containerWrapper",
  "editButton": "navYmm-module-scss-module__6XuKka__editButton",
  "selection": "navYmm-module-scss-module__6XuKka__selection",
  "ymmTextWrapper": "navYmm-module-scss-module__6XuKka__ymmTextWrapper",
});
